import { cloneDeep } from 'lodash';
import store from '@/store/index';

export default {
  bind(el, binding) {
    const route = cloneDeep(store.state.route);
    // eslint-disable-next-line no-param-reassign
    el.dataset.elementText = binding.value.elementText;
    // eslint-disable-next-line no-param-reassign
    el.dataset.eventActionResult = binding.value.eventActionResult;
    // eslint-disable-next-line no-param-reassign
    el.dataset.elementSubtype = binding.value.elementSubtype;
    // eslint-disable-next-line no-param-reassign
    el.analyticsClickHandler = async () => {
      const { elementText, eventActionResult, elementSubtype } = el.dataset;
      await store.dispatch('analytics/ctaInteractionEvent', {
        elementText,
        eventActionResult,
        elementSubtype,
        route,
      });
    };
    el.addEventListener('click', el.analyticsClickHandler);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      // eslint-disable-next-line no-param-reassign
      el.dataset.elementText = binding.value.elementText;
      // eslint-disable-next-line no-param-reassign
      el.dataset.eventActionResult = binding.value.eventActionResult;
      // eslint-disable-next-line no-param-reassign
      el.dataset.elementSubtype = binding.value.elementSubtype;
    }
  },
};
